import { useContext, useEffect, useRef, useState } from "react";
import { PortalContext } from "../../../context/Provider";
import HeaderModal from "../../Genericos/headerModal/headerModal";
import Timer from "../../Genericos/Timer/Timer";
import ScrollArrows from "../../Genericos/ScrollArrows/ScrollArrows";
import "./Preparaciones.css";

const Preparaciones = ({ titulo, dissmiss, preparacion, autorizacion }) => {
  const { turnosPacienteState } = useContext(PortalContext);
  const [disable, setDisable] = useState(true);
  const [hasScroll, setHasScroll] = useState(false);
  const containerRef = useRef(null);

  const onChangeTemporizador = () => {
    setDisable(false);
  };

  // Mostrar flechas de scroll solo si el contenido desborda el container.
  useEffect(() => {
    if (!containerRef.current) return;
    const el = containerRef.current;
    setHasScroll(el.scrollHeight > el.clientHeight);
  }, [preparacion, autorizacion]);

  return (
    <>
      <HeaderModal
        titulo={titulo}
        dissmiss={
          turnosPacienteState.turnosPaciente.ultimoTurno !== null
            ? () => {}
            : dissmiss
        }
      />
      <div
        ref={containerRef}
        className="ptur-modalPreparaciones-container"
      >
        {
          <>
            {autorizacion ? (
              <div className="ptur-modalPreparaciones-txt">
                <p className="ptur-modalPreparaciones-tituloReqAut rb16b">
                  Requiere Autorización
                </p>
                <p className="ptur-modalPreparaciones-textReqAut">
                  Su turno requiere autorizacion de su cobertura médica
                </p>
              </div>
            ) : (
              ""
            )}
            {preparacion !== null && preparacion !== "" && !autorizacion ? (
              ""
            ) : preparacion === "" && autorizacion ? (
              ""
            ) : (
              <p className="ptur-modalPreparaciones-tituloPreparacion rb16b">
                Preparaciones
              </p>
            )}
            <div
              className="ptur-modalPreparaciones-txt"
              dangerouslySetInnerHTML={{ __html: preparacion }}
            ></div>
          </>
        }
      </div>
      {hasScroll && (
        <ScrollArrows targetSelector=".ptur-modalPreparaciones-container" />
      )}
      <div className="ptur-modalPreparaciones-btnContainer">
        {turnosPacienteState.turnosPaciente.ultimoTurno !== null ? (
          <button
            className={
              disable
                ? "ptur-modalPreparaciones-btnDsb c-latex30 bgc-white rb18l"
                : "ptur-modalPreparaciones-btn c-latex30 bgc-white rb18l"
            }
            disabled={disable ? true : false}
            onClick={dissmiss}
            style={disable ? { cursor: "unset" } : { cursor: "pointer" }}
          >
            {disable ? (
              <Timer onChange={onChangeTemporizador} />
            ) : (
              "Confirmo que leí la preparación"
            )}
          </button>
        ) : (
          <button
            className="ptur-modalPreparaciones-btn c-latex30 bgc-white rb18l"
            onClick={dissmiss}
          >
            Cerrar
          </button>
        )}
      </div>
    </>
  );
};

export default Preparaciones;
